import React from 'react';
import { InputNumberProps } from 'antd';

import {
  StyledAntdInputNumber,
} from './style';

const CVInputNumber = (props: InputNumberProps): JSX.Element => (
  <StyledAntdInputNumber {...props} />
);

export default CVInputNumber;
